function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 12.5419C8.44928 12.5419 7.60143 12.1946 6.97631 11.5764C6.35119 10.9582 6 10.1197 6 9.24549C6 8.37123 6.35119 7.53278 6.97631 6.91459C7.60143 6.2964 8.44928 5.94911 9.33333 5.94911C10.2174 5.94911 11.0652 6.2964 11.6904 6.91459C12.3155 7.53278 12.6667 8.37123 12.6667 9.24549C12.6667 9.67837 12.5804 10.107 12.4129 10.507C12.2454 10.9069 11.9999 11.2703 11.6904 11.5764C11.3808 11.8825 11.0134 12.1253 10.6089 12.2909C10.2045 12.4566 9.77107 12.5419 9.33333 12.5419ZM9.33333 0.015625C6.85798 0.015625 4.48401 0.988054 2.73367 2.71899C0.98333 4.44992 0 6.79757 0 9.24549C0 16.1679 9.33333 26.3867 9.33333 26.3867C9.33333 26.3867 18.6667 16.1679 18.6667 9.24549C18.6667 6.79757 17.6833 4.44992 15.933 2.71899C14.1827 0.988054 11.8087 0.015625 9.33333 0.015625Z",
  fill: "#FF8674"
});

var SvgOrangeMarker = function SvgOrangeMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrangeMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orangeMarker.c2ab1100.svg";
export { ForwardRef as ReactComponent };